import $                  from 'jquery';
import template           from './template.hbs';
import emailErrorsPartial from './email-errors-partial.hbs';
import FormStep           from '../../classes/form-step';
import validateEmail      from '../../util/email';

export default new FormStep({
  $el: $('<form class="form-step step-create-account" action="canvas" />'),
  template,
  events: {
    'submit-clicked': 'track'
  },
  rules: {
    email: validateEmail,
    // minimum 8 characters, no spaces.
    password: /^(\S+){8,}$/
  },
  isValid( state ) {
    const { emailIsValid } = this.localState;
    return emailIsValid && FormStep.prototype.isValid.call( this, state );
  },
  validateEmail: ( () => {
    let toggleTimeout = '';
    let ajaxTimeout   = '';
    let xhr           = { abort: () => {} };

    return function( email, debounce ) {
      const validEmailSyntax = validateEmail( email );
      xhr.abort();
      clearTimeout( toggleTimeout );
      clearTimeout( ajaxTimeout );

      if ( !validEmailSyntax ) {
        return this.renderEmailMarkup({
          errorText: 'Please enter a valid email address'
        });
      }

      const url = `${ window.cloudURL }/email/${ email }`;

      this.renderEmailMarkup({ errorText: '' });

      const validationCall = () => {
        toggleTimeout = setTimeout(
          this.toggleLoading.bind( this, true ),
          500
        );

        xhr = $.ajax( url, {
          complete: ({ status }) => {
            const errorText = this.getEmailResponseText( status );

            clearTimeout( toggleTimeout );

            this.toggleLoading( false );
            this.setState({ emailIsValid: ( status === 404 ) });
            this.renderEmailMarkup({ errorText });
            // fire change event to trigger step validation
            this.dispatch({ type: 'change', data: {} });
          }
        });
      };

      if ( debounce === true ) {
        ajaxTimeout = setTimeout( validationCall, 500  );
      } else {
        validationCall();
      }

    };
  })(),
  bindEvents() {
    this.$el.on( 'input', 'input#email', ( evt ) => {
      this.toggleLoading( false );
      this.setState({ emailIsValid: false });
      this.renderEmailMarkup({ errorText: '' });
      this.validateEmail( evt.target.value, true );
    });
    return FormStep.prototype.bindEvents.call( this );
  },
  render( state ) {
    // disable 'next' on step load until new validation is run
    this.setState({ emailIsValid: false });

    const errorText        = ( state.errors && state.errors.email ) || '';
    const emailErrorMarkup = emailErrorsPartial({ errorText });
    const extended         = Object.assign( {}, state, { emailErrorMarkup } );

    !errorText && this.validateEmail( state.email );
    return FormStep.prototype.render.call( this, extended );
  },
  getEmailResponseText( statusCode ) {
    let text = '';

    switch ( statusCode ) {
      case 200:
        text = 'This email is already in use';
        break;
      case 400:
        text = 'Please enter a valid email address';
        break;
      case 404:
        text = '';
        break;
      default:
        text = 'Something went wrong. Please try again.';
    }

    return text;
  },
  renderEmailMarkup( tokens ) {
    const markup = emailErrorsPartial( tokens );
    this.$el.find('.js-emailErrorContainer').html( markup );
  },
  toggleLoading( isLoading = false ) {
    const action = isLoading ? 'addClass' : 'removeClass';
    this.$el.find('.input-wrap')[ action ]('loading');
  },
  track( state ) {
    if ( window.acumen ) {
      window.acumen.track( 'web-submit-create_account', {
        email: state.email || null
      });

      if ( state.email ) {
        window.acumen.identify({ email: state.email });
      }
    }
  }
});
